import FormErrorCodes from './form';

export const PortugueseErrorCodes = {
  ...FormErrorCodes,
};
